import React, { FC } from 'react';
import { TextInputWrapper } from 'components/forms';
import { Field, Form } from 'react-final-form';
import { ISignInFormFields } from '../SignIn/constants';
import { Button } from 'components/ui';
import { sendPasswordResetCode } from '../store/actions';
import { useHistory } from 'react-router';
import routesByName from 'constants/routes';
import { useDispatchRequest, useMutation } from '@redux-requests/react';
import FormError from '../FormError/FormError';
import { AuthConstants } from '../store/constants';
import { t } from 'utils';

const Forgotten: FC = () => {
  const { error } = useMutation({ type: AuthConstants.RESET_PASSWORD });
  const dispatch = useDispatchRequest();
  const history = useHistory();

  const handleSubmit = async (formValues: Pick<ISignInFormFields, 'email'>): Promise<void> => {
    const { email } = formValues;
    const { data } = await dispatch(sendPasswordResetCode(email));

    if (data) {
      history.push(routesByName.auth.index);
    }
  };

  return (
    <Form
      onSubmit={handleSubmit}
      // validate={(values) => {
      //   const { email } = values;
      //   if (email && !emailPattern.test(email)) {
      //     return { email: intl({ id: 'errors.emailInvalid' }) };
      //   }
      // }}
      // validateOnBlur
      render={({ handleSubmit, submitting, pristine }) => (
        <form className='mb-5' onSubmit={handleSubmit}>
          <Field
            label='global.email'
            placeholder='global.email.placeholder'
            name='email'
            component={TextInputWrapper}
            type='email'
            className='mb-5'
          />
          {error && <FormError />}
          <Button disabled={submitting || pristine} inline>
            {t('request.new.password')}
          </Button>
        </form>
      )}
    />
  );
};

export default Forgotten;
